import { Injectable } from '@angular/core';
import 'rxjs/add/operator/publishReplay';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class DataStore {
	private data: {
		[key: string]: Observable<any>,
	} = {};

	public get(key: string, observable: () => Observable<any>) {
		console.log('DataStore::get()', key, this.data);

		if (this.data[key] === undefined) {
			this.data[key] = observable().publishReplay(1).refCount();
		}

		return this.data[key];
	}
}



// WEBPACK FOOTER //
// ./src/app/core/providers/data.ts